<template>
    <highcharts :options="chartOptions"></highcharts>
</template>

<script>
import { Chart } from 'highcharts-vue'
import { BLUE_COLOUR, GRAY_COLOUR, BACKGROUND_COLOUR, GREEN_COLOUR, RED_COLOUR } from '@/constants/colours.js'
import { formatDateByMonthLong, formatDateByMonth } from '@/helpers/date.helpers'
import { TEST_PHYSICAL_ACTIVITY } from '@/constants/patientServices'
import selfEvaluationTestMixin from '@/mixins/selfEvaluationTest.mixin'

export default {
    mixins: [selfEvaluationTestMixin],
    components: {
        'highcharts': Chart
    },
    props: {
        lastYearResults: {
            type: Array,
            required: true
        },
        testName: {
            type: String,
            required: true
        },
        customChart: {
            type: Object,
            required: false
        },
        percentages: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        chartOptions () {
            var _this = this
            var months = []
            // si se quisiese añadir los meses intermedios que no se rellenan sólo habría que eliminar la lista months y en lugar de (name: month) poner (x: month) En el xAxis recuperar el type datetime con el tickInterval

            const result = this.lastYearResults.map((item) => {
                const day = new Date(item.date)
                const month = Date.UTC(day.getFullYear(), day.getMonth())
                months.push(formatDateByMonth(day))
                return {
                    name: month,
                    y: this.percentages ? item.percentage : item.generalResult,
                    date: day,
                    color: this.testName === this.$t('tests.mediterranean-diet.title') ? item.generalResult >= 8 ? GREEN_COLOUR : RED_COLOUR : this.testName === this.$t('tests.physical-activity.title') ? this.testResultsInfo(TEST_PHYSICAL_ACTIVITY, item.percentage).color : BLUE_COLOUR
                }
            })

            return {
                chart: {
                    type: 'column',
                    backgroundColor: BACKGROUND_COLOUR,
                    height: this.$uiHelpers.isMobile ? '50%' : this.$uiHelpers.isTablet ? '35%' : '200',
                    width: this.$uiHelpers.isMobile || this.$uiHelpers.isTablet ? null : result.length <= 3 ? result.length * 195 : result.length <= 6 ? result.length * 140 : null
                },
                title: {
                    text: ''
                },
                credits: {
                    enabled: false
                },
                tooltip: this.customChart && this.customChart.tooltip ? this.customChart.tooltip : {
                    formatter: function () {
                        return `<b>${formatDateByMonthLong(this.point.date).replace(/^\w/, c => c.toUpperCase())}</b><br>
                                ${_this.testName}: <b>${this.point.y}%</b>`
                    }
                },
                xAxis: {
                    type: 'category',
                    categories: months,
                    // type: 'datetime',
                    // tickInterval: 31 * 24 * 3600 * 1000,
                    // tickLength: 0,
                    labels: {
                        formatter: function () {
                            return this.value === formatDateByMonth(new Date()) ? `<span style="color: ${BLUE_COLOUR};"><b> ${this.value} </b></span>` : this.value
                        }
                    }
                },
                yAxis: this.customChart && this.customChart.yAxis ? this.customChart.yAxis : {
                    title: null,
                    tickInterval: 25,
                    max: 100,
                    gridLineWidth: 0.4,
                    gridLineColor: GRAY_COLOUR
                },
                series: [{
                    data: result
                }],
                plotOptions: {
                    column: {
                        borderWidth: 0,
                        showInLegend: false,
                        pointWidth: this.$uiHelpers.isMobile ? 10 : this.$uiHelpers.isTablet ? 20 : 50
                        // cursor: 'pointer',
                        // point: {
                        //     events: {
                        //         click: function () {
                        //             _this.$store.commit('tests/setDBResult', _this.$store.state.tests.previousTestResults[1])
                        //         }
                        //     }
                        // }
                    }
                }
            }
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/charts/ColumnChart.vue